// crickets
import HeaderInit from './components/header';
import TransitionInit from './components/transitions';

HeaderInit();
TransitionInit();
